import React, { useRef } from 'react';

const Star = ({ size, style, delay, duration }: { size: number, style: React.CSSProperties, delay: number, duration: number, key?: any }) => (
  <div
    className="absolute bg-white rounded-full opacity-30 shadow-[0_0_5px_rgba(255,255,255,0.5)] star-anim"
    style={{ 
      ...style, 
      width: size, 
      height: size,
      animationDuration: `${duration}s`,
      animationDelay: `${delay}s`
    }}
  />
);

const BigStar = () => {
  return (
    <div
      className="absolute w-20 h-20 md:w-32 md:h-32 z-10 big-star-anim"
    >
        {/* Trail effect */}
        {[1, 2, 3].map((i) => (
             <div
                key={i}
                className="absolute inset-0"
                style={{ opacity: 0.5 - i * 0.1, transform: `scale(${1 - i * 0.2})` }}
             >
                <svg viewBox="0 0 24 24" className="w-full h-full fill-yellow-500/50">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
            </div>
        ))}
        {/* Main Star */}
        <svg viewBox="0 0 24 24" className="w-full h-full fill-yellow-400 drop-shadow-[0_0_15px_rgba(250,204,21,0.6)] md:drop-shadow-[0_0_25px_rgba(250,204,21,0.8)] relative z-10">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
    </div>
  );
};

export const StarBackground = () => {
  const starsArray = Array.from({ length: 40 }).map(() => ({
    size: Math.random() * 3 + 1,
    duration: Math.random() * 10 + 10,
    delay: Math.random() * -20, // Negative delay to start at random points
    style: {
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`
    } // added closing bracket for style object. Wait no it's just object fields, let me close properly below
  }));

  return (
    <div className="fixed inset-0 z-[-1] overflow-hidden bg-near-black">
      <style>{`
        @keyframes starRise {
          0% { transform: translateY(100vh); opacity: 0; }
          10% { opacity: 0.5; }
          40% { opacity: 0.5; }
          60% { opacity: 0; }
          100% { transform: translateY(-100vh); opacity: 0; }
        }
        .star-anim {
          animation: starRise linear infinite;
        }
        @keyframes bigStarMove {
          0% { transform: translate(120vw, 10vh); }
          100% { transform: translate(-20vw, 80vh); }
        }
        .big-star-anim {
          animation: bigStarMove 20s linear infinite;
        }
      `}</style>
      <BigStar />
      {starsArray.map((star, i) => <Star key={100+i} size={star.size} style={star.style} delay={star.delay} duration={star.duration} />)}
    </div>
  );
};